<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Donation Amount">
                    <div>
                      <FormRow>
                            <LazyCurrencySelector :currencies="['ILS', 'USD', 'CAD']" style="max-width: 180px;" />
                        </FormRow>
                      <AmountSelectorList @update:emittedDescription="handleUpdate"/>
                      <ErrorLabel field="amount" />

                    </div>
                    <div v-if="form.amount && selectedDescription == 'Torat Imecha Halacha - One Day Sponsorship'">
                      <FormRow>
                        <div>
                        <label class="radio"
                          ><input type="radio" value="no" :checked="nachyomiDate === 'no'" @change="setNachyomiDate('no')" />&nbsp; I do not want to specify a date</label
                        >
                        <label class="radio"
                          ><input type="radio" value="yes" :checked="nachyomiDate === 'yes'" @change="setNachyomiDate('yes')" />&nbsp; I want to specify a date</label
                        >
                      </div>
                      </FormRow>
                      <div class="nach-yomi-date" v-if="nachyomiDate === 'yes'">
                        <label class="control-label">Torat Imecha Nach Yomi Day</label>
                        <FormRow>
                          <input type="date" class="date-input" @change="setDayDate(new Date($event.target.value))" />
                        </FormRow>
                      </div>
                    </div>
                    <div v-if="form.amount && (selectedDescription == 'Torat Imecha Haftorah Audio Shiur - Weekly Sponsorship' || selectedDescription == 'Torat Imecha Nach Yomi Audio Shiur - One Day Sponsorship')">
                      <div class="note" v-if="selectedDescription !== 'Torat Imecha Haftorah Audio Shiur - Weekly Sponsorship'">
                        <p>
                          To see when a particular perek will take place, visit the Torat Imecha Nach Yomi calendar at <a href="https://res.cloudinary.com/ouwp/images/v1768325263/ouredesign/main/WI-Nach-Yomi_2026-2028_v6/WI-Nach-Yomi_2026-2028_v6.pdf?_i=AA" target="_blank">ouwomen.org/torat-imecha</a>
                        </p>
                      </div>

                      <FormRow>
                        <div>
                        <label class="radio"
                          ><input type="radio" value="no" :checked="nachyomiDate === 'no'" @change="setNachyomiDate('no')" />&nbsp; I do not want to specify a date</label
                        >
                        <label class="radio"
                          ><input type="radio" value="yes" :checked="nachyomiDate === 'yes'" @change="setNachyomiDate('yes')" />&nbsp; I want to specify a date</label
                        >
                      </div>
                      </FormRow>
                      <div class="nach-yomi-date" v-if="nachyomiDate === 'yes'">
                        <label class="control-label">Torat Imecha Nach Yomi Day</label>
                        <FormRow>
                          <input type="date" class="date-input" @change="setDayDate(new Date($event.target.value))" />
                        </FormRow>
                      </div>
                    </div>
                    <div v-if="form.amount && selectedDescription == 'Torat Imecha Nach Yomi Audio Shiur - One Week Sponsorship'">
                      <div class="note">
                        <p>
                          To see when a particular perek will take place, visit the Torat Imecha Nach Yomi calendar at <a href="https://res.cloudinary.com/ouwp/images/v1768325263/ouredesign/main/WI-Nach-Yomi_2026-2028_v6/WI-Nach-Yomi_2026-2028_v6.pdf?_i=AA" target="_blank">ouwomen.org/torat-imecha</a>
                        </p>
                      </div>
                      <FormRow>
                        <div>
                        <label class="radio"
                          ><input type="radio" value="no" :checked="nachyomiDate === 'no'" @change="setNachyomiDate('no')" />&nbsp; I do not want specify a date</label
                        >
                        <label class="radio"
                          ><input type="radio" value="yes" :checked="nachyomiDate === 'yes'" @change="setNachyomiDate('yes')" />&nbsp; I want to specify a date</label
                        >
                        </div>
                      </FormRow>
                      <div class="nach-yomi-date" v-if="nachyomiDate === 'yes'">
                        <label class="control-label">Torat Imecha Nach Yomi week start date</label>
                        <FormRow>
                          <input type="date" class="date-input" @change="setWeekDate(new Date($event.target.value))" />
                        </FormRow>
                      </div>
                    </div>
                    <div v-if="form.amount && selectedDescription == 'Torat Imecha Nach Yomi Audio Shiur - One Month Sponsorship'">
                      <label class="control-label">Torat Imecha Nach Yomi month</label>
                      <FormRow>
                        <div>
                          <select @change="setValue('custom.ti_nachyomi_month', $event.target.value.toString())">
                            <option :value="1">January</option>
                            <option :value="2">February</option>
                            <option :value="3">March</option>
                            <option :value="4">April</option>
                            <option :value="5">May</option>
                            <option :value="6">June</option>
                            <option :value="7">July</option>
                            <option :value="8">August</option>
                            <option :value="9">September</option>
                            <option :value="10">October</option>
                            <option :value="11">November</option>
                            <option :value="12">December</option>
                          </select>
                        </div>
                        <div style="margin-left:16px ">
                          <select @change="setValue('custom.ti_nachyomi_year', $event.target.value.toString())">
                            <option :value="2024">2024</option>
                            <option :value="2025">2025</option>
                          </select>
                        </div>
                      </FormRow>
                    </div>
                    <InHonorOfOuwomen />
                  </FormSection>
                  <FormSection title="Donation Frequency">
                    <div class="frequency">
                      <PaymentOptions addSplit addMonthly monthlyText="Recurring Monthly Gift" />
                    </div>
                  </FormSection>

                  <FormSection title="Personal Information">
                      <FormRow inline>
                          <FormCol field="title" :flex="1" />
                          <FormCol field="firstName" :flex="2" />
                          <FormCol field="lastName" :flex="2" />
                      </FormRow>
                      <FormRow inline>
                          <FormCol field="email" />
                          <FormCol field="phone" />
                      </FormRow>
                      <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>
                      <DonorAddress />
                      <FormRow>
                        <NewsletterSubscribe text="Sign me up to the OU Women's Initiative Newsletter" />
                      </FormRow>
                  </FormSection>
                  <FormSection v-if="form.amount">
                    <TransactionFee />
                  </FormSection>
                  <FormSection title="Payment Information" last>
                      <FormRow>
                          <Receipt :receipts="['israel','us']"/>
                      </FormRow>
                      <FormRow inline>
                      <FormCol field="card" :showLabel="false"/>
                      </FormRow>
                  </FormSection>
                  <PaymentButton btnText="Donate Now" showAmount/>
              </PaymentForm>
          </div>
      </div>
  </div>
  </template>

  <script lang="ts">
  import { computed, watch, defineComponent, ref } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

  export default defineComponent({
    props: {
      subCampaign: String,
    },
    setup() {
      const { setValue, getValue, form } = usePaymentForm();
      setValue('custom.nachyomiDate', 'no');

      const selectedDescription = ref<string | null>(null);

      const handleUpdate = (value: string | null) => {
        selectedDescription.value = value;
        setValue('description', value);
      };
      const params = queryParams();

      watch(
        [() => form.value.amount, selectedDescription],
        () => {
          if (params.code) {
            if (params.code === "Hakarat") {
              setValue('applications.0.campaign', 'Hakarat Hatov');
            } else if (params.code === "lechknnos") {
              setValue('applications.0.campaign', 'Lech Knos');
            }
          } else if (selectedDescription.value === 'Torat Imecha Nach Yomi Audio Shiur - One Week Sponsorship' || selectedDescription.value === 'Torat Imecha Nach Yomi Audio Shiur - One Day Sponsorship' || selectedDescription.value === 'Torat Imecha Nach Yomi Audio Shiur - One Month Sponsorship' || selectedDescription.value === 'Torat Imecha Parsha - Weekly Sponsorship' || selectedDescription.value === 'Torat Imecha Haftorah Audio Shiur - Weekly Sponsorship') {
            setValue('applications.0.campaign', 'Torat Imecha');
            setValue('applications.0.subCampaign', 'Torat Imecha Nach Yomi');
          } else if (selectedDescription.value === 'Torat Imecha Parsha - One Sefer Sponsorship' || selectedDescription.value === 'Torat Imecha Parsha - One Year Sponsorship') {
            setValue('applications.0.campaign', 'Torat Imecha');
            setValue('applications.0.subCampaign', 'Parsha');
          } else if (selectedDescription.value === 'Torat Imecha Halacha - One Day Sponsorship' || selectedDescription.value === 'Torat Imecha Halacha - One Month Sponsorship') {
            setValue('applications.0.campaign', 'Halacha');
            setValue('applications.0.subCampaign', '');
          } else {
            setValue('applications.0.campaign', 'General Donation');
            setValue('applications.0.subCampaign', '');
          }
        },
        { immediate: true }
      );



      const setNachyomiDate = (val: string) => { setValue('custom.nachyomiDate', val); };

      return {
        nachyomiDate: computed(() => getValue('custom.nachyomiDate')),
        setNachyomiDate,
        handleUpdate,
        selectedDescription,
        form,
        setValue,
        setWeekDate(date: Date) {
          setValue(
            "custom.ti_nachyomi_start_week",
            new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString()
          );
        },
        setDayDate(date: Date) {
          setValue(
            "custom.ti_nachyomi_day",
            new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString()
          );
        }
      }
    },
  })
  </script>
  <style scoped lang="scss">
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }
  .note {
    font-size: 14px;
    padding: 15px 10px;
    margin-bottom: 15px;
    background: rgb(255 255 230);
    border-radius: 6px;
    border: 1px solid #f7f7e7;
    line-height: 1.2;
  }
  .form-container ou-donation-form{
    padding: 30px 20px;
    max-height: none !important;
    height: auto !important;
  }
  .control-label {
        flex: 1;
        font-size: 14px;
        padding-top: 3px;
        padding-bottom: 3px;
        display: block;
        color: #222;
    }
    label.radio {
      font-size: 14px;
      color: #222;
      padding-top: 3px;
      padding-bottom: 3px;
      display: block;
    }
    .date-input {
      width: 100%;
      padding: 8px 12px;
      font-size: 14px;
      border: 1px solid #ccc;
      border-radius: 4px;
      color: #222;
    }
    ::v-deep .amount-row:nth-child(5),
    ::v-deep .amount-row:nth-child(10) {
      position:relative;
      &:after {
        content: 'New!';
        position: absolute;
        top: -8px;
        right: -10px;
        background: #ff0000;
        color: #fff;
        font-size: 10px;
        padding: 2px 5px;
        border-radius: 3px;
      }
    }
  </style>
